import { render, staticRenderFns } from "./Callbot.vue?vue&type=template&id=7274d4e3&scoped=true"
import script from "./Callbot.vue?vue&type=script&lang=ts"
export * from "./Callbot.vue?vue&type=script&lang=ts"
import style0 from "./Callbot.vue?vue&type=style&index=0&id=7274d4e3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274d4e3",
  null
  
)

export default component.exports